/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_Product_MuscuInputs */

const fr_membership_plan_change_product_muscu = /** @type {(inputs: Membership_Plan_Change_Product_MuscuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscu`)
};

/**

* @param {Membership_Plan_Change_Product_MuscuInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_product_muscu = /** @type {((inputs?: Membership_Plan_Change_Product_MuscuInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Product_MuscuInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_product_muscu(inputs)
});